// src/components/modals/DeleteCommentModal.tsx
import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

interface DeleteCommentModalProps {
  isOpen: boolean;
  toggle: () => void;
  onConfirm: () => void;
}

const DeleteCommentModal: React.FC<DeleteCommentModalProps> = ({
  isOpen, toggle, onConfirm
}) => (
  <Modal isOpen={isOpen} toggle={toggle} className={`${localStorage.getItem("mode") ? localStorage.getItem("mode") : "light"}`}>
    <ModalHeader
      className="modal-header-style theme-text-color"
    >Deletar Comentário</ModalHeader>
    <ModalBody className="modal-body-style">
      <b style={{ color: "red" }}>
        Você tem certeza que deseja excluir esse comentário? Essa ação não poderá ser desfeita.
      </b>
    </ModalBody>
    <ModalFooter className="modal-footer-style">
      <Button color="primary" onClick={onConfirm}>Confirmar</Button>
      <Button color="secondary" onClick={toggle}>Cancelar</Button>
    </ModalFooter>
  </Modal>
);

export default DeleteCommentModal;
